import { useEffect, useState } from 'react';

import type { AiModelsCatalogModel } from '@/domain/models/ai-model.js';
import type { ListAiModels } from '@/domain/use-cases/ai-models.js';

type State = {
    catalog: AiModelsCatalogModel | null;
    isLoading: boolean;
    error: string | null;
};

export function useAiModels(listAiModelsUseCase: ListAiModels) {
    const [state, setState] = useState<State>({ catalog: null, isLoading: true, error: null });

    useEffect(() => {
        let active = true;
        listAiModelsUseCase.execute().then((result) => {
            if (!active) {
                return;
            }
            result.fold(
                (error) => setState({ catalog: null, isLoading: false, error: error.message }),
                (catalog) => setState({ catalog, isLoading: false, error: null })
            );
        });
        return () => {
            active = false;
        };
    }, [listAiModelsUseCase]);

    return state;
}
